import React from 'react';
import { FormattedMessage } from 'react-intl';
import globalMessages from '../Cap/messages';
import { INDIVIDUAL } from '../Cap/constants';

//feature gate keys
export const GIFT_CARDS = 'GIFT_CARDS';
export const PROMO_ENGINE = 'PROMO_ENGINE';

export const REQUEST = 'REQUEST';
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';

export const UPCOMING = 'UPCOMING';
export const LIVE = 'LIVE';
export const EXPIRED = 'EXPIRED';
export const LOYALTY = 'LOYALTY';
export const ENGAGE = 'ENGAGE';
export const MILESTONE = 'MILESTONE';
export const JOURNEY = 'JOURNEY';
export const JOURNEYS = 'JOURNEYS';
export const REFERRAL_CAMPAIGNS = 'REFERRAL_CAMPAIGNS';
export const AUDIENCE_CAMPAIGNS = 'AUDIENCE_CAMPAIGNS';
export const REWARDS_CATALOG = 'REWARDS_CATALOG';
export const GOODWILL_MODULE = 'GOODWILL_MODULE';
export const MEMBERCARE = 'MEMBERCARE';
export const HISTORICAL_IMPORT = 'HISTORICAL_IMPORT';

export const ACTIVE = 'ACTIVE';
export const INACTIVE = 'INACTIVE';

export const UN_EARNED = 'UN_EARNED';
export const EARNED = 'EARNED';
export const IN_PROGRESS = 'IN_PROGRESS';

export const DATE_DISPLAY_FORMAT = 'DD MMM YYYY';
export const DATE_FORMAT = 'YYYY-MM-DD';

export const COMPLETE = 'COMPLETE';

export const MODE_DELETE = 'DELETE';
export const MODE_UPDATE = 'UPDATE';
export const IDLE = 'IDLE';

export const getSettingsMenuData = () => [
  {
    title: <FormattedMessage {...globalMessages.customFields} />, 
    key: 'customFields',
    link: `/badges/ui/settings/custom-fields`,
  },
  {
    title: <FormattedMessage {...globalMessages.badgeGroups} />,
    key: 'badgeGroups',
    link: `/badges/ui/settings/badge-groups`,
  },
  // {
  //   title: <FormattedMessage {...globalMessages.message} />,
  //   key: 'message',
  //   link: `/badges/ui/settings/message`,
  // },
  // {
  //   title: <FormattedMessage {...globalMessages.reports} />,
  //   key: 'reports',
  //   link: `/badges/ui/settings/report-settings`,
  // },
  // {
  //   title: <FormattedMessage {...globalMessages.alerts} />,
  //   key: 'alerts',
  //   link: `/badges/ui/settings/alerts`,
  // },
];

export const getTopbarMenuDataValue = () => [
  // {
  //   label: <FormattedMessage {...globalMessages.tab1} />,
  //   link: '/',
  //   key: 'programs',
  // },
];

export const badgesTypeKeys = {
  [IN_PROGRESS]: 'inProgress',
  [UN_EARNED]: 'unIssued',
  [EARNED]: 'issued',
};

export const badgesTypes = [UN_EARNED, IN_PROGRESS, EARNED];

export const ISSUE_EARN = 'ISSUE_EARN';
export const EARN = 'EARN';

export const BADGES_UI_ENABLED = 'BADGES_UI_ENABLED';
export const CREATE_BADGE_ENABLED = 'CREATE_BADGE_ENABLED';

export const moduleMessageMap = {
  Loyalty: 'loyalty',
  Loyalty_Promotion: 'loyaltyPromotion',
  Referral_Campaigns: 'referralCampaign',
  Journeys: 'journey',
  Audience_Campaigns: 'broadcastCampaign',
  Rewards_Catalog: 'rewardsCatalog',
  Goodwill_Module: 'goodwillModule',
  Milestones: 'milestone',
  Historical_Import: 'historicalImport',
};

export const OwnerNamesMap = {
  LOYALTY: 'Loyalty',
  LOYALTY_PROMOTION: 'Loyalty Promotion',
  JOURNEY: 'Journey',
  AUDIENCE_CAMPAIGNS: 'Audience Campaign',
  REWARDS_CATALOG: 'Rewards Catalog',
  GOODWILL_MODULE: 'Goodwill Module',
  MEMBERCARE: 'Membercare',
  HISTORICAL_IMPORT: 'Historical Import',
};

export const POST = 'POST';
export const PUT = 'PUT';

export const VIEW = 'VIEW';
export const EDIT = 'EDIT';
export const DUPLICATE = 'DUPLICATE';
export const CREATE = 'CREATE';
export const PREVIEW = 'PREVIEW';

export const errorMessageMap = {
  MODULE_NOT_IMPLEMENTED: 'moduleNotImplementedError',
  NOT_FOUND: 'notFoundError',
  INVALID_REFERENCE_ID: 'invalidReferenceIdError',
  ACCESS_FORBIDDEN: 'accessForbiddenError',
};

export const INDIVIDUAL_CUSTOMER_LIMIT = 'INDIVIDUAL_CUSTOMER_LIMIT';
export const ACROSS_CUSTOMER_LIMIT = 'ACROSS_CUSTOMER_LIMIT';

export const FIXED_WINDOW = 'FIXED_WINDOW';
export const MOVING_WINDOW = 'MOVING_WINDOW';

export const CUSTOMER_BADGE_FIXED_VALUE = 'CUSTOMER_BADGE_FIXED_VALUE';
export const CUSTOMER_BADGE_ROLLING_WINDOW = 'CUSTOMER_BADGE_ROLLING_WINDOW';
export const BADGE_FIXED_VALUE = 'BADGE_FIXED_VALUE';
export const BADGE_ROLLING_WINDOW = 'BADGE_ROLLING_WINDOW';
export const CUSTOMER_BADGE_FIXED_WINDOW = 'CUSTOMER_BADGE_FIXED_WINDOW';
export const BADGE_FIXED_WINDOW = 'BADGE_FIXED_WINDOW';

export const SPECIFIC_NO_OF_DAYS = 'SPECIFIC_NO_OF_DAYS';
export const SPECIFIC_WEEKDAY = 'SPECIFIC_WEEKDAY';
export const CALANDER_MONTH = 'CALANDER_MONTH';

export const EDIT_COUPON_SERIES = 'editCouponSeries';
export const CREATE_COUPON_SERIES = 'createCouponSeries';
export const VIEW_COUPON_SERIES = 'viewCouponSeries';

export const DESC = 'DESC';
export const ASC = 'ASC';

export const DATE = "DATE"

export const LOYALTY_POINTS = 'LOYALTY_POINTS';
export const COUPON = 'COUPON';
export const CART_PROMOTION = 'CART_PROMOTION';
export const GIFT_VOUCHER = 'GIFT_VOUCHER';

export const supportedBadgeBenefits = {
  LOYALTY_POINTS,
  COUPON,
  CART_PROMOTION,
  GIFT_VOUCHER,
};

export const DAY_SMALL_CASE = 'day';
export const STRING_SMALL_CASE = 'string'

export const MODAL_WINDOW_MAX_WIDTH = '35.429rem';

export const ENABLE_BADGE_BENEFITS = 'ENABLE_BADGE_BENEFITS';